import styled from 'styled-components';

const StyledPicture = styled.picture`
  display: block;

  img {
    width: 100%;
  }
`;

export default StyledPicture;
